var map = {
	"./BaseWidgetForm.vue": "306b",
	"./ContactDataWidget.vue": "8b73",
	"./EventHeaderWidget.vue": "5cd2",
	"./EventListWidget.vue": "4af5",
	"./FAQWidget.vue": "2af2",
	"./FormWidget.vue": "d023",
	"./GalleryWidget.vue": "c474",
	"./HTMLWidget.vue": "7a59",
	"./LinkListWidget.vue": "5ca0",
	"./LogotypesWidget.vue": "45d3",
	"./NewsWidget.vue": "4ef3",
	"./NewsletterWidget.vue": "d8f8",
	"./SliderWidget.vue": "1d41",
	"./TextWidget.vue": "ce64",
	"./TicketsWidget.vue": "b87b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f7e1";